import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CONST_URL_SEGEMENTS } from 'paylink-constants';
import { WidgetResponse } from '../interfaces/widget.interface';
import { ApiService } from './api.service';
import { buildWidgetApiPath } from '../utils/widget-api-path.util';

export interface WidgetCompanyResponse {
  uuid: string;
  logo?: string;
  company_name?: string;
  name_primary_language?: string;
  purchase_portal_theme?: string | Record<string, unknown>;
}

@Injectable({
  providedIn: 'root',
})
export class WidgetService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiService);

  getWidgetDetails(widgetId: string): Observable<WidgetResponse> {
    const path = buildWidgetApiPath(
      CONST_URL_SEGEMENTS.OPEN_API.WIDGETS.GET_WIDGET_BY_UUID,
      { widget_id: widgetId },
    );
    return this.http
      .get<WidgetResponse>(`${this.apiService.getBaseApiUrl()}${path}`)
      .pipe(catchError(this.handleError));
  }

  getCompanyDetails(companyUuid: string): Observable<WidgetCompanyResponse> {
    const path = buildWidgetApiPath(
      CONST_URL_SEGEMENTS.OPEN_API.GET_COMPANYBYID,
      { company_uuid: companyUuid },
    );
    return this.http
      .get<WidgetCompanyResponse>(`${this.apiService.getBaseApiUrl()}${path}`)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Client error:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
          `body was: ${JSON.stringify(error.error)}`,
      );
    }

    return throwError(
      () =>
        new Error(
          'Something went wrong with the widget initialization. Please try again later.',
        ),
    );
  }
}
